"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const KeyEnum_1 = require("./KeyEnum");
global.Keys = KeyEnum_1.KeyCodes;
if (typeof window !== 'undefined')
    window.Keys = KeyEnum_1.KeyCodes;
